import $ from 'jquery';
import { LocalStorage } from '../../../core/utils/Storage';

$(document).ajaxSuccess(function(event, request) {
	const { web_version } = request.responseJSON;

	if (web_version) {
		LocalStorage.set('web_version', web_version);
	}
});